import { ReactNode } from "react";

export default function PlayerLayout({ children }: { children: ReactNode }) {
  return (
    <div className={"fixed items-center h-full top-0 bottom-0 w-full bg-neutral-800"}>
      {children}
    </div>
  );
}
